/* Waifu Wicks – UI behaviours for the custom sections (header, product page, creator page,
   related tabs, footer, homepage countdown). Loaded once, deferred, cached.
   Every block is keyed on data attributes so sections can appear more than once. */
(function () {
  'use strict';
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var lock = function (on) { document.documentElement.classList.toggle('ww-locked', on); };

  /* ---------------- Header: drawer, search overlay, dropdowns ---------------- */
  function initHeader() {
    var header = document.querySelector('[data-ww-header]');
    if (!header) return;
    var drawer = document.getElementById('mobile-drawer');
    var overlay = document.getElementById('mobile-overlay');
    var openBtn = document.getElementById('mobile-menu-toggle');
    var closeBtn = document.getElementById('mobile-drawer-close');
    var search = document.getElementById('search-overlay');
    var searchBtn = document.getElementById('search-toggle');
    var searchClose = document.getElementById('search-close');
    var lastFocus = null;

    function openDrawer() {
      lastFocus = document.activeElement;
      drawer.hidden = false; overlay.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); overlay.classList.add('is-open'); });
      openBtn.setAttribute('aria-expanded', 'true'); lock(true); closeBtn.focus();
    }
    function closeDrawer() {
      drawer.classList.remove('is-open'); overlay.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false'); lock(false);
      setTimeout(function () { drawer.hidden = true; overlay.hidden = true; }, 250);
      if (lastFocus) lastFocus.focus();
    }
    function openSearch() {
      lastFocus = document.activeElement;
      search.hidden = false; searchBtn.setAttribute('aria-expanded', 'true'); lock(true);
      var i = search.querySelector('input[type="search"]'); if (i) i.focus();
    }
    function closeSearch() {
      search.hidden = true; searchBtn.setAttribute('aria-expanded', 'false'); lock(false);
      if (lastFocus) lastFocus.focus();
    }
    if (openBtn && drawer) {
      openBtn.addEventListener('click', openDrawer);
      closeBtn.addEventListener('click', closeDrawer);
      overlay.addEventListener('click', closeDrawer);
    }
    if (searchBtn && search) {
      searchBtn.addEventListener('click', openSearch);
      searchClose.addEventListener('click', closeSearch);
      search.addEventListener('click', function (e) { if (e.target === search) closeSearch(); });
      initPredictive(search);
    }
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (drawer && !drawer.hidden) closeDrawer();
      if (search && !search.hidden) closeSearch();
      $$('.ww-nav__item--drop.is-open').forEach(function (li) { li.classList.remove('is-open'); });
    });
    $$('.ww-nav__item--drop', header).forEach(function (li) {
      var link = li.querySelector('.ww-nav__link');
      function set(open) { li.classList.toggle('is-open', open); link.setAttribute('aria-expanded', open ? 'true' : 'false'); }
      li.addEventListener('mouseenter', function () { set(true); });
      li.addEventListener('mouseleave', function () { set(false); });
      li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) set(false); });
      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); set(true); var f = li.querySelector('.ww-mega a'); if (f) f.focus(); }
      });
      link.addEventListener('touchend', function (e) { if (!li.classList.contains('is-open')) { e.preventDefault(); set(true); } });
    });
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* Predictive search: filters the creator chips instantly and asks Shopify's
     /search/suggest.json for matching products and collections. */
  function money(amount) {
    // amount in major units (Ajax API strings like "28.00") or cents (number, isCents)
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(amount); }
    catch (e) { return '$' + Number(amount).toFixed(2); }
  }
  window.WWMoney = money;

  function initPredictive(panel) {
    var input = panel.querySelector('input[type="search"]');
    var results = panel.querySelector('[data-ww-results]');
    var chips = $$('[data-ww-creator-chip]', panel);
    if (!input || !results) return;
    var timer, ctrl;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function split(title) {
      var m = String(title).split(/\s[–—|-]\s/);
      return m.length > 1 ? { lead: m[0], name: m.slice(1).join(' – ') } : { lead: '', name: title };
    }
    function render(q, products, colls) {
      var html = '';
      if (products.length) {
        html += '<p class="ww-search__suggest-title">Products</p><ul class="ww-search__list ww-search__list--products">' + products.map(function (p) {
          var t = split(p.title);
          var varies = p.price_max != null && p.price_min != null && Number(p.price_max) > Number(p.price_min);
          var amount = varies ? p.price_min : p.price;
          var price = amount != null && amount !== '' ? '<span class="ww-search__price">' + (varies ? '<span class="ww-search__from">From </span>' : '') + esc(money(amount)) + '</span>' : '';
          var sold = p.available === false ? '<span class="ww-search__sold">Sold out</span>' : '';
          return '<li><a href="' + esc(p.url) + '">' +
            (p.image ? '<img src="' + esc(p.image) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="ww-search__ph"></span>') +
            '<span class="ww-search__text"><span class="ww-search__name">' + esc(t.name) + '</span>' + (t.lead ? '<span class="ww-search__lead">' + esc(t.lead) + '</span>' : '') + '</span>' +
            '<span class="ww-search__meta">' + price + sold + '</span></a></li>';
        }).join('') + '</ul>';
      }
      if (colls.length) {
        html += '<p class="ww-search__suggest-title">Creators &amp; collections</p><ul class="ww-search__list ww-search__list--colls">' + colls.map(function (c) {
          return '<li><a href="' + esc(c.url) + '">' + (c.image ? '<img src="' + esc(c.image) + '" alt="" width="40" height="40" loading="lazy" class="ww-search__avatar">' : '') + '<span class="ww-search__name">' + esc(c.title) + '</span></a></li>';
        }).join('') + '</ul>';
      }
      if (!products.length && !colls.length) {
        html += '<p class="ww-search__empty">No matches for “' + esc(q) + '” yet. Try a creator name or a scent like “vanilla”.</p>';
      }
      html += '<a class="ww-link-arrow ww-search__all" href="' + root + 'search?q=' + encodeURIComponent(q) + '&amp;options%5Bprefix%5D=last">See all results for “' + esc(q) + '” →</a>';
      results.innerHTML = html;
      results.hidden = false;
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      var ql = q.toLowerCase();
      chips.forEach(function (c) { c.parentNode.hidden = ql && c.textContent.toLowerCase().indexOf(ql) === -1; });
      clearTimeout(timer);
      if (q.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        var local = chips.filter(function (c) { return c.textContent.toLowerCase().indexOf(ql) !== -1; }).map(function (c) { return { title: c.textContent.trim(), url: c.getAttribute('href'), image: c.dataset.image }; });
        fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last', { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var res = (d && d.resources && d.resources.results) || {};
            var products = (res.products || []).map(function (p) { return { title: p.title, url: p.url, image: p.image || (p.featured_image && p.featured_image.url), price: p.price, price_min: p.price_min, price_max: p.price_max, available: p.available }; });
            var colls = (res.collections || []).map(function (c) { return { title: c.title, url: c.url, image: c.featured_image && c.featured_image.url }; });
            local.forEach(function (l) { if (!colls.some(function (c) { return c.url === l.url; })) colls.push(l); });
            render(q, products, colls.slice(0, 6));
          })
          .catch(function (e) { if (e && e.name === 'AbortError') return; render(q, [], local); });
      }, 160);
    });
  }

  /* ---------------- Product page ---------------- */
  function initProduct(root) {
    var form = root.querySelector('form.ww-pdp__form');
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-ww-variants]').textContent); } catch (e) { /* none */ }
    var strings = { add: root.dataset.addText || 'Add to cart', sold: root.dataset.soldText || 'Sold out', unavailable: 'Unavailable' };
    var mainImg = root.querySelector('.ww-gallery__main img.ww-gallery__img');
    function q(sel) { return $$(sel, root); }
    function setMain(src, alt) { if (!mainImg || !src) return; mainImg.removeAttribute('srcset'); mainImg.src = src; if (alt != null) mainImg.alt = alt; }

    q('[data-ww-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        setMain(b.dataset.src, b.dataset.alt);
        q('[data-ww-thumb]').forEach(function (x) { x.removeAttribute('aria-current'); });
        b.setAttribute('aria-current', 'true');
      });
    });

    var qty = form && form.querySelector('input[name="quantity"]');
    q('[data-ww-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        qty.value = Math.min(99, Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.wwQty, 10)));
      });
    });
    if (qty) qty.addEventListener('change', function () { qty.value = Math.min(99, Math.max(1, parseInt(qty.value, 10) || 1)); });

    function selected() { var s = []; q('[data-ww-option]:checked').forEach(function (i) { s[+i.dataset.wwOption] = i.value; }); return s; }
    function find(sel) { return variants.find(function (v) { return sel.every(function (val, i) { return v.options[i] === val; }); }); }
    function markAvailability(sel) {
      q('[data-ww-option]').forEach(function (input) {
        var test = sel.slice(); test[+input.dataset.wwOption] = input.value;
        var v = find(test);
        var label = root.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !v || !v.available);
      });
    }
    function update(v) {
      var onSale = v && v.compare_at_price > v.price;
      var ok = v && v.available;
      q('[data-ww-price]').forEach(function (el) { el.textContent = v ? v.price_fmt : ''; el.classList.toggle('ww-price--sale', !!onSale); });
      q('[data-ww-compare]').forEach(function (el) { el.hidden = !onSale; });
      q('[data-ww-compare-amount]').forEach(function (el) { el.textContent = onSale ? v.compare_fmt : ''; });
      q('[data-ww-sale-badge]').forEach(function (el) { el.hidden = !onSale || !ok; });
      if (onSale) { var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price); q('[data-ww-save]').forEach(function (el) { el.textContent = pct; }); }
      q('[data-ww-soldout-badge]').forEach(function (el) { el.hidden = !v || v.available; });
      q('[data-ww-notify]').forEach(function (el) { el.hidden = !!ok; });
      q('[data-ww-qty], .ww-qty input').forEach(function (el) { el.disabled = !ok; });
      q('[data-ww-atc]').forEach(function (btn) {
        btn.disabled = !ok;
        if (ok) btn.removeAttribute('aria-disabled'); else btn.setAttribute('aria-disabled', 'true');
        btn.querySelector('[data-ww-atc-label]').textContent = !v ? strings.unavailable : (v.available ? strings.add : strings.sold);
      });
      q('[data-ww-sticky-variant]').forEach(function (el) { el.textContent = v && v.title !== 'Default Title' ? v.title : ''; el.hidden = !(v && v.title !== 'Default Title'); });
      if (v) {
        form.querySelector('[data-ww-variant-id]').value = v.id;
        form.dataset.wwVariant = v.title === 'Default Title' ? '' : v.title;
        form.dataset.wwUnitPrice = v.price;
        q('[data-ww-notify-variant]').forEach(function (el) { el.value = v.title; });
        if (v.image) setMain(v.image);
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    if (form) {
      form.addEventListener('change', function (e) {
        if (!e.target.matches('[data-ww-option]')) return;
        var sel = selected();
        q('[data-ww-opt-value="' + e.target.dataset.wwOption + '"]').forEach(function (el) { el.textContent = e.target.value; });
        update(find(sel)); markAvailability(sel);
      });
      markAvailability(selected());
      if (root.dataset.variantTitle) form.dataset.wwVariant = root.dataset.variantTitle;
    }

    // Back-in-stock form: submit in place, keep the normal POST as the no-JS fallback.
    var notify = root.querySelector('[data-ww-notify] form');
    if (notify && window.fetch) {
      notify.addEventListener('submit', function (e) {
        var email = notify.querySelector('input[type="email"]');
        if (email && !email.checkValidity()) return; // let the browser show its message
        e.preventDefault();
        var btn = notify.querySelector('[type="submit"]');
        if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
        fetch(notify.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(notify), headers: { Accept: 'text/html' } })
          .then(function (r) {
            if (!r.ok || /challenge/.test(r.url)) throw new Error('fallback');
            var box = notify.parentNode;
            box.innerHTML = '<p class="ww-notify__ok" role="status" tabindex="-1">✓ You\u2019re on the list ✨ We\u2019ll email ' + (email ? email.value.replace(/[<>&"]/g, '') : 'you') + ' when it\u2019s back.</p>';
            var ok = box.querySelector('.ww-notify__ok'); if (ok) ok.focus();
          })
          .catch(function () { notify.submit(); });
      });
    }

    // Sticky mobile buy bar: shown once the main button has scrolled away, hidden again near the footer.
    var sticky = root.querySelector('[data-ww-sticky]');
    var mainBtn = form && form.querySelector('[data-ww-atc]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      document.body.classList.add('ww-has-sticky');
      var buttonOff = false, nearFooter = false;
      var apply = function () {
        var show = buttonOff && !nearFooter;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelector('[data-ww-atc]').tabIndex = show ? 0 : -1;
      };
      // Only after the whole buy area (price → Add to Cart) has scrolled ABOVE the viewport, so the
      // bar and the main button are never both on screen.
      var buyArea = root.querySelector('.ww-buy') || mainBtn;
      new IntersectionObserver(function (en) { var e = en[0]; buttonOff = !e.isIntersecting && e.boundingClientRect.top < 0; apply(); }).observe(buyArea);
      var foot = document.querySelector('.ww-footer');
      if (foot) new IntersectionObserver(function (en) { nearFooter = en[0].isIntersecting; apply(); }).observe(foot);
    }
  }

  /* ---------------- Creator collection: filter + sort ---------------- */
  function initCollection(root) {
    var grid = root.querySelector('[data-ww-grid]');
    if (!grid) return;
    var items = $$('[data-ww-item]', grid);
    var empty = root.querySelector('[data-ww-empty]');
    var count = root.querySelector('[data-ww-count]');
    items.forEach(function (li, i) { li.dataset.order = i; });
    var buttons = $$('.ww-filter', root);
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.dataset.filter, shown = 0;
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        items.forEach(function (li) {
          var card = li.querySelector('.ww-card');
          var ok = f === 'all' || (card && card.dataset.type === f);
          li.hidden = !ok; if (ok) shown++;
        });
        if (empty) empty.hidden = shown > 0;
        if (count) count.textContent = shown + (shown === 1 ? ' product' : ' products');
      });
    });
    var sort = root.querySelector('[data-ww-sort]');
    if (sort) sort.addEventListener('change', function () {
      var v = sort.value;
      var d = function (li, k) { var c = li.querySelector('.ww-card'); return c ? parseInt(c.dataset[k], 10) || 0 : 0; };
      items.sort(function (a, b) {
        if (v === 'price-low') return d(a, 'price') - d(b, 'price');
        if (v === 'price-high') return d(b, 'price') - d(a, 'price');
        if (v === 'newest') return d(b, 'created') - d(a, 'created');
        return a.dataset.order - b.dataset.order;
      });
      items.forEach(function (li) { grid.appendChild(li); });
    });
  }

  /* ---------------- Tabs (related products) ---------------- */
  function initTabs(root) {
    var tabs = $$('[data-ww-tab]', root);
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); t.tabIndex = t === tab ? 0 : -1; });
        $$('[data-ww-panel]', root).forEach(function (p) { p.hidden = p.dataset.wwPanel !== tab.dataset.wwTab; });
      });
      tab.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        var next = tabs[(i + d + tabs.length) % tabs.length]; next.focus(); next.click();
      });
    });
  }

  /* ---------------- Rail arrows (scroll the visible rail in the same section) ---------------- */
  function initRailNav(nav) {
    var section = nav.closest('section');
    function rail() { return $$('.ww-rail', section).filter(function (r) { return r.offsetParent !== null; })[0]; }
    function sync() {
      var r = rail(); if (!r) return;
      var max = r.scrollWidth - r.clientWidth - 2;
      nav.hidden = max <= 0;
      nav.querySelector('[data-dir="-1"]').disabled = r.scrollLeft <= 2;
      nav.querySelector('[data-dir="1"]').disabled = r.scrollLeft >= max;
    }
    $$('button', nav).forEach(function (b) {
      b.addEventListener('click', function () { var r = rail(); if (r) r.scrollBy({ left: parseInt(b.dataset.dir, 10) * r.clientWidth * 0.9, behavior: 'smooth' }); });
    });
    $$('.ww-rail', section).forEach(function (r) { r.addEventListener('scroll', sync, { passive: true }); });
    $$('[data-ww-tab]', section).forEach(function (t) { t.addEventListener('click', function () { setTimeout(sync, 50); }); });
    window.addEventListener('resize', sync); sync();
  }

  /* ---------------- Countdown (category promo panel) ---------------- */
  function initCountdown(timer) {
    var deadline = new Date(timer.getAttribute('data-deadline'));
    if (isNaN(deadline)) { timer.hidden = true; return; }
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var diff = Math.max(0, deadline - new Date());
      var d = Math.floor(diff / 864e5); diff -= d * 864e5;
      var h = Math.floor(diff / 36e5); diff -= h * 36e5;
      var m = Math.floor(diff / 6e4); diff -= m * 6e4;
      timer.querySelector('.pcg__days').textContent = pad(d);
      timer.querySelector('.pcg__hours').textContent = pad(h);
      timer.querySelector('.pcg__mins').textContent = pad(m);
      timer.querySelector('.pcg__secs').textContent = pad(Math.floor(diff / 1000));
    };
    tick(); setInterval(tick, 1000);
  }

  /* ---------------- Footer back-to-top ---------------- */
  function initBackToTop() {
    var b = document.getElementById('backToTop');
    if (!b) return;
    window.addEventListener('scroll', function () { b.classList.toggle('is-visible', window.scrollY > 600); }, { passive: true });
    b.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      var m = document.getElementById('MainContent'); if (m) m.focus({ preventScroll: true });
    });
  }

  /* ---------------- Read more collapse ---------------- */
  function initCollapse(box) {
    var btn = box.querySelector('[data-ww-collapse-btn]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Show less' : 'Read more';
    });
  }

  /* ---------------- Cart page: quantity steppers (update via Ajax API, then refresh) ---------------- */
  function initCartPage(root) {
    var form = root.querySelector('[data-ww-cart-form]');
    if (!form) return;
    var timer;
    var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    function push() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var updates = $$('input[name="updates[]"]', form).map(function (i) { return Math.max(0, parseInt(i.value, 10) || 0); });
        root.classList.add('is-updating');
        fetch(cartRoot + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
          .then(function () { window.location.reload(); })
          .catch(function () { form.submit(); });
      }, 500);
    }
    $$('[data-ww-cart-qty]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentNode.querySelector('input');
        input.value = Math.min(99, Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.wwCartQty, 10)));
        push();
      });
    });
    $$('input[name="updates[]"]', form).forEach(function (i) { i.addEventListener('change', push); });
  }

  function init() {
    initHeader();
    $$('[data-ww-pdp]').forEach(initProduct);
    $$('[data-ww-coll]').forEach(initCollection);
    $$('[data-ww-tabs]').forEach(initTabs);
    $$('[data-deadline]').forEach(initCountdown);
    $$('[data-ww-rail-nav]').forEach(initRailNav);
    $$('[data-ww-collapse]').forEach(initCollapse);
    $$('[data-ww-cart-page]').forEach(initCartPage);
    initBackToTop();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
